export var ERROR = 'not_valid_personal_id';
var PERSONL_ID_REGEX = /[1-8]{1}[0-9]{10}/;
var MULTIPLIERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1];
var ADDITIONAL_MULTIPLIERS = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3];
var CHECKSUM_DIVIDER = 11;
var CHECKSUM_REMAINDER = 10;
var FALLBACK_CONTROL_NUMBER = 0;

var getChecksum = function getChecksum(multipliers, personalIdParts) {
  return personalIdParts.split('').reduce(function (checksum, currentValue, index) {
    var multiplier = multipliers[index];
    return checksum + currentValue * multiplier;
  }, 0);
};

var isPossibleControlNumber = function isPossibleControlNumber(checksumRemainder) {
  return checksumRemainder !== CHECKSUM_REMAINDER;
};
/**
 * Creates validator for lt personalId
 *
 * @function personalIdLithuania
 * @return {validator} lt personalId validator
 */


export default function personalIdLithuania() {
  return function (personalId) {
    if (!personalId || !PERSONL_ID_REGEX.test(personalId)) {
      return ERROR;
    }

    var controlNumber = parseInt(personalId.slice(-1), 10);
    var personalIdParts = personalId.slice(0, -1);

    var isCorrectControlNumber = function isCorrectControlNumber(possibleControlNumber) {
      if (controlNumber === possibleControlNumber) {
        return null;
      }

      return ERROR;
    };

    var checksum = getChecksum(MULTIPLIERS, personalIdParts);
    var checksumRemainder = checksum % CHECKSUM_DIVIDER;

    if (isPossibleControlNumber(checksumRemainder)) {
      return isCorrectControlNumber(checksumRemainder);
    }

    checksum = getChecksum(ADDITIONAL_MULTIPLIERS, personalIdParts);
    checksumRemainder = checksum % CHECKSUM_DIVIDER;

    if (isPossibleControlNumber(checksumRemainder)) {
      return isCorrectControlNumber(checksumRemainder);
    }

    return isCorrectControlNumber(FALLBACK_CONTROL_NUMBER);
  };
}